// extracted by mini-css-extract-plugin
module.exports = {"filterBox":"styles_filterBox__6BYgR"};